import {Component, inject, input} from '@angular/core';
import {
  ProviderTenderRfqControllerService,
  ProviderTenderServiceFeesUpsertRequest,
  UpsertServiceFeesRequestParams,
  ProviderTenderImplementationFeesUpsertRequest,
  UpsertImplementationFeesRequestParams,
  ProviderTenderIntegrationSetupFeesUpsertRequest,
  UpsertIntegrationSetupFeesRequestParams,
  ProviderTenderIntegrationOtherFeesUpsertRequest,
  UpsertIntegrationOtherFeesRequestParams,
} from '@frontend/shared-api';
import {Step823RfqPreviewPriceListComponent} from '../../../../customer/project-sequence/chapter/chapter-8-rfq/step-8-2-invitation-preview/step-8-2-3-rfq-price-list/step-8-2-3-rfq-preview-price-list.component';
import {LoadingComponent} from '../../../../../shared/components/loading/loading.component';
import {firstValueFrom} from 'rxjs';
import {ToastService} from '@frontend/toast';
import {rxResource} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-tender-project-rfq-price-list',
  imports: [Step823RfqPreviewPriceListComponent, LoadingComponent],
  templateUrl: './tender-rfq-price-list.component.html',
})
export class TenderRfqPriceListComponent {
  private readonly toastService = inject(ToastService);
  private readonly providerTenderRfqService = inject(ProviderTenderRfqControllerService);

  readonly tenderId = input.required<number>();
  readonly isReadOnly = input<boolean>(false);

  protected readonly invitationOfferOverviewResource = rxResource({
    params: () => ({tenderId: this.tenderId()}),
    stream: ({params: request}) =>
      this.providerTenderRfqService.getTenderInvitationOfferOverview(request),
  });

  protected async saveServiceFees($event: ProviderTenderServiceFeesUpsertRequest[]) {
    const request = {
      tenderId: this.tenderId(),
      providerTenderServiceFeesUpsertRequest: $event,
    } as UpsertServiceFeesRequestParams;

    try {
      const updatedResponse = await firstValueFrom(
        this.providerTenderRfqService.upsertServiceFees(request),
      );
      this.invitationOfferOverviewResource.set(updatedResponse);
      void this.toastService.showSuccessMessage();
    } catch (err) {
      console.error('Update ServiceFees failed:', err);
    }
  }

  protected async saveImplementationFees($event: ProviderTenderImplementationFeesUpsertRequest[]) {
    const request = {
      tenderId: this.tenderId(),
      providerTenderImplementationFeesUpsertRequest: $event,
    } as UpsertImplementationFeesRequestParams;

    try {
      const updatedResponse = await firstValueFrom(
        this.providerTenderRfqService.upsertImplementationFees(request),
      );
      this.invitationOfferOverviewResource.set(updatedResponse);
      void this.toastService.showSuccessMessage();
    } catch (err) {
      console.error('Update ImplementationFees failed:', err);
    }
  }

  protected async saveIntegrationSetupFees(
    $event: ProviderTenderIntegrationSetupFeesUpsertRequest[],
  ) {
    const request = {
      tenderId: this.tenderId(),
      providerTenderIntegrationSetupFeesUpsertRequest: $event,
    } as UpsertIntegrationSetupFeesRequestParams;

    try {
      const updatedResponse = await firstValueFrom(
        this.providerTenderRfqService.upsertIntegrationSetupFees(request),
      );
      this.invitationOfferOverviewResource.set(updatedResponse);
      void this.toastService.showSuccessMessage();
    } catch (err) {
      console.error('Update IntegrationSetupFees failed:', err);
    }
  }

  protected async saveIntegrationOtherFees(
    $event: ProviderTenderIntegrationOtherFeesUpsertRequest[],
  ) {
    const request = {
      tenderId: this.tenderId(),
      providerTenderIntegrationOtherFeesUpsertRequest: $event,
    } as UpsertIntegrationOtherFeesRequestParams;

    try {
      const updatedResponse = await firstValueFrom(
        this.providerTenderRfqService.upsertIntegrationOtherFees(request),
      );
      this.invitationOfferOverviewResource.set(updatedResponse);
      void this.toastService.showSuccessMessage();
    } catch (err) {
      console.error('Update IntegrationOtherFees failed:', err);
    }
  }
}
